export default "__VITE_ASSET___8eAT_DU__"